var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConversationDarkIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 6.25C12.5 4.62062 12.5 3.80593 12.2662 3.15244C11.8627 2.02481 10.9752 1.1373 9.84756 0.733824C9.19407 0.5 8.37938 0.5 6.75 0.5V0.5C5.12062 0.5 4.30593 0.5 3.65244 0.733824C2.52481 1.1373 1.6373 2.02481 1.23382 3.15244C1 3.80593 1 4.62062 1 6.25V10.5C1 11.4428 1 11.9142 1.29289 12.2071C1.58579 12.5 2.05719 12.5 3 12.5H6.5C8.36377 12.5 9.29565 12.5 10.0307 12.1955C11.0108 11.7895 11.7895 11.0108 12.1955 10.0307C12.5 9.29565 12.5 8.36377 12.5 6.5V6.25Z",
    stroke: "#525B7A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.59375 5L8.90625 5",
    stroke: "#525B7A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.59375 8H6.75",
    stroke: "#525B7A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversationDarkIcon);
export default __webpack_public_path__ + "static/media/conversationDarkIcon.62f167f548f99f56851a4b482e8a3316.svg";
export { ForwardRef as ReactComponent };